import React, { useEffect, useState } from 'react';
import { useParams} from 'react-router-dom';
import ChartDashboardViewr from './ChartDashboardViewr';
import ChartDashboardCreator from './ChartDashboardCreator';

import { ReactComponent as ExportIcon } from '../icons/home/export.svg';

import { API_BASE_URL, ItemList, fetchData, handleDuplicate, handleDelete, renderConfirmationModal, renderModal, closeModal, LoadingOverlay } from './Common';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const exportDashboardAsJPG = () => {
  html2canvas(document.querySelector(".react-grid-layout"), { useCORS: true }).then(canvas => {
    const link = document.createElement("a");
    link.download = "dashboard.jpg";
    link.href = canvas.toDataURL("image/jpeg");
    link.click();
  });
};


const exportDashboardAsPDF = () => {
    html2canvas(document.querySelector(".react-grid-layout"), { useCORS: true }).then(canvas => {
      const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210; // A4 width in mm
      const pageHeight = 295; // A4 height in mm
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("dashboard.pdf");
    });
  };

function Project() {
  const { projectId } = useParams();
  const [tables, setTables] = useState([]);
  const [tableColumnData, setTableColumnData] = useState([]);
  const [isTableColumnDataLoaded, setIsTableColumnDataLoaded] = useState(false);
  const [isTablesLoaded, setIsTablesLoaded] = useState(false);

  const [isDuplicating, setIsDuplicating] = useState(false);
  const [spinnerMessage, setSpinnerMessage] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const [dashboardToDelete, setDashboardToDelete] = useState(null);
  const [dashboards, setDashboards] = useState([]);
  const [isDashboardsLoaded, setIsDashboardsLoaded] = useState(false);

  const [widgets, setWidgets] = useState([]);
  const [isWidgetsLoaded, setIsWidgetsLoaded] = useState(false);

  const [modalIconId, setModalIconId] = useState(0);

  const [showChartWidgetCreator, setShowChartWidgetCreator] = useState(false);

  const [projectName, setProjectName] = useState('');
  const [isProjectNameLoaded, setIsProjectNameLoaded] = useState(false);
  const [selectedWidgetId, setSelectedWidgetId] = useState(null);
  const [viewDashboardId, setviewDashboardId] = useState(null);

  const [exportModalVisible, setExportModalVisible] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // Track current page number
  const itemsPerPage = 10; // Maximum items per page

  useEffect(() => {

    fetchData(`${API_BASE_URL}/project/${projectId}`, setProjectName, setIsProjectNameLoaded, 'name');

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables');

    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

    fetchData(`${API_BASE_URL}/widgets/${projectId}`, setWidgets, setIsWidgetsLoaded, 'widgetData');

    fetchData(`${API_BASE_URL}/dashboards/${projectId}`, setDashboards, setIsDashboardsLoaded, 'dashboardData');
  }, [projectId]); // Include projectId in the dependency array to refetch tables when projectId changes

const handleButtonClick = () => {
  if(selectedWidgetId) setSelectedWidgetId (null);
  else if(viewDashboardId) setviewDashboardId (null);
  else setShowChartWidgetCreator(prevState => !prevState); // Invert the state to show/hide ChartWidgetCreator
};

const confirmDeleteDashboard = async () => {
  setviewDashboardId(null);
  setModalIconId(0);
        const token = localStorage.getItem('token');
        await handleDelete('dashboards', null, dashboardToDelete, token, setDashboards, dashboards, setModalMessage, setModalMessageColor, setIsModalOpen, currentPage, setCurrentPage, itemsPerPage);
        setIsConfirmationModalOpen(false);
    };

    const handleExportDashboard = async (dashboardId) => {
    setviewDashboardId(dashboardId);
    setExportModalVisible(true);
  };

  const handleSaveLayout = async (tableId) => {
    setModalMessage("Dashboard guardado!");
    setModalMessageColor('#43BBC9');
    setModalIconId(3);
    setIsModalOpen(true);


  };

  const handleDownload = async (format) => {
        switch (format) {
          case 'JPG':
            exportDashboardAsJPG();
            break;
          case 'PDF':
            exportDashboardAsPDF();
            break;
          default:
            break;
    }
    setExportModalVisible(false);
  };

function ExportModal(visible, handleDownloadFunc, setModalVisibleFunc, showCSVOption) {

  const [selectedFormat, setSelectedFormat] = useState('PDF');
  const [urlSharingEnabled, setUrlSharingEnabled] = useState(false);

  useEffect(() => {
    setUrlSharingEnabled(dashboards[viewDashboardId]?.URLshare || false);
  }, []);


  const handleCheckboxChange = (format) => {
    if (selectedFormat !== format) {
      setSelectedFormat(format);
    }
  };

  const generateShareableUrl = () => {
    return `${window.location.origin}/${projectId}/${viewDashboardId}/${dashboards[viewDashboardId]?.share_code}`;
  };
  //requere https
  /*const handleCopyUrl = () => {
    const url = generateShareableUrl();
    navigator.clipboard.writeText(url).then(() => {
      alert('URL copiado para o clipboard');
    }).catch((err) => {
      console.error('Failed to copy URL: ', err);
    });
  };*/
  const handleCopyUrl = () => {
    const url = generateShareableUrl();

    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = url;

    // Append to the document and select the text
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // for mobile devices

    try {
        document.execCommand('copy');
        alert('URL copiado para o clipboard');
    } catch (err) {
        console.error('Failed to copy URL: ', err);
    }

    // Clean up by removing the temporary input
    document.body.removeChild(tempInput);
};


  const handleUrlToggle = async (enabled,dashboardId) => {
  setUrlSharingEnabled(enabled);

  const response = await fetch(`${API_BASE_URL}/dashboards/${dashboardId}/toggle-sharing`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}` // Assuming token is stored in localStorage
      },
      body: JSON.stringify({ isShared: enabled })
    });

  if (response.ok) {
      //setSharingEnabled(newSharingStatus); // Update local state
    } else {
      console.error('Failed to update sharing status');
    }
  };

  return (
    visible && (
      <div className="export-modal">
      <ExportIcon/>
      <span className="close" onClick={() => setModalVisibleFunc(false)}>&times;</span>
      <p className="modal-title">Exportar dados</p>
      <p className="modal-intro">Selecionar formato</p>
      <div>
        {showCSVOption && (
  <div className="toggle-copy-container">
    <label className="toggle-switch">
      <span>Partilhar URL</span>
      <input
        type="checkbox"
        checked={urlSharingEnabled}
        onChange={() => handleUrlToggle(!urlSharingEnabled,viewDashboardId)} // Handle switch toggle
      />
      <span className="slider"></span>
    </label>
    {urlSharingEnabled && (
      <button className="copy-url-btn" onClick={handleCopyUrl}>
        <span>Copiar URL</span>
      </button>
    )}
  </div>
)}

        <label>
          <input
            type="checkbox"
            value="JPG"
            checked={selectedFormat === 'JPG'}
            onChange={() => handleCheckboxChange('JPG')}
          />
          <span>JPG</span>
        </label>
        <label>
          <input
            type="checkbox"
            value="PDF"
            checked={selectedFormat === 'PDF'}
            onChange={() => handleCheckboxChange('PDF')}
          />
          <span>PDF</span>
        </label>
      </div>
      <button onClick={() => handleDownloadFunc(selectedFormat)}>
      <span>Download</span>
      </button>
    </div>
    )
  );
}

const handleDuplicateDashboard = (dashboardId) => {
    handleDuplicate(
      'dashboard',
      dashboardId,
      setDashboards,
      dashboards,
      'Dashboard Duplicado!',
      setIsDuplicating,
      setModalMessage,
      setModalMessageColor,
      setIsModalOpen
    );
  };
const handleDeleteClick = (dashboardId) => {
  setDashboardToDelete(dashboardId);
  setIsConfirmationModalOpen(true);
    };

  const hasReadOnlyPermission = Object.values(tables).some(table => table.permission === 'read-only');

  return (
  <div className="home-container">

  {!showChartWidgetCreator &&  (<>
    <p className="text0">Gerir dashboards</p>
    <p>Acesso à lista de todos dashboards do projeto</p>
    <p className="text1">{projectName}</p>

    {!viewDashboardId && (
    <ItemList
      tipo="dashboard"
      isLoaded={isTableColumnDataLoaded}
      onEdit={setviewDashboardId}
      onExport={handleExportDashboard}
      onDelete={handleDeleteClick}
      onDuplicate={handleDuplicateDashboard}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      DataArray={dashboards}
      itemsPerPage={itemsPerPage}
      />
)}
</>)}

{renderConfirmationModal(isConfirmationModalOpen, "Tem a certeza que pretende eliminar o dashboard?", confirmDeleteDashboard, () => setIsConfirmationModalOpen(false))}

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

{ExportModal(exportModalVisible, handleDownload, setExportModalVisible, true)}

<div>

<div className="button-container">
<button
  className="button"
  onClick={() => {
    if (!isTablesLoaded || (hasReadOnlyPermission && !viewDashboardId && !selectedWidgetId && !showChartWidgetCreator)) {
      return; // Prevent any action if tables are not loaded or in read-only mode
    }
    handleButtonClick();
  }}
  style={{
    cursor: !isTablesLoaded || (hasReadOnlyPermission && !viewDashboardId && !selectedWidgetId && !showChartWidgetCreator) ? 'not-allowed' : 'pointer',
    opacity: !isTablesLoaded || (hasReadOnlyPermission && !viewDashboardId && !selectedWidgetId && !showChartWidgetCreator) ? 0.5 : 1,
  }}
  disabled={!isTablesLoaded || (hasReadOnlyPermission && !viewDashboardId && !selectedWidgetId && !showChartWidgetCreator)} // Disable button if tables are not loaded or in read-only mode
>
  {(viewDashboardId || selectedWidgetId || showChartWidgetCreator) ? 'Voltar' : 'Criar Dashboard'}
</button>

</div>

{!selectedWidgetId && viewDashboardId && (

  <>
    {(() => {

      return (
      <ChartDashboardViewr
        widgets={widgets}
        tables={tables}
        dashboard={dashboards[viewDashboardId]}
        DashboardId={viewDashboardId}
        permission={dashboards[viewDashboardId].permission}
        setDashboards={setDashboards}
        setWidgets={setWidgets}
        setIsWidgetsLoaded={setIsWidgetsLoaded}
        setIsDashboardsLoaded={setIsDashboardsLoaded}
        projectId={projectId}
        setIsDuplicating={setIsDuplicating}
        setSpinnerMessage={setSpinnerMessage}
        onSave={handleSaveLayout}
        onDelete={handleDeleteClick}
        onDuplicate={handleDuplicateDashboard}
        onExport={handleExportDashboard}
        isTablesLoaded={isTablesLoaded}

tableColumnData={tableColumnData}
      />
      );
    })()}
  </>
)}

{showChartWidgetCreator && (
      <ChartDashboardCreator
        tableColumnData={tableColumnData}
        isTablesLoaded={isTablesLoaded}
        projectId={projectId}
        setDashboards={setDashboards}
      />
)}

</div>

<LoadingOverlay isDuplicating={isDuplicating} spinnerMessage={spinnerMessage}/>

</div>
);

}

export default Project;
